<template>
  <div>
    <form>
      <div class="form-group row">
        <label for="searchProviders" class="col-sm-4 col-form-label">Aðilar</label>
        <div class="col-sm-8">
          <select id="searchProviders" class="form-control" v-model="searchFilter.SearchProviders" multiple>
            <option v-for="option in providers" v-bind:value="option.id" :key="option.id">
              {{ option.ShortName }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="PageSize" class="col-sm-4 col-form-label">Fjöldi á síðu</label>
        <div class="col-sm-8">
          <input 
            id="PageSize" 
            class="form-control" 
            type="number" 
            v-model="searchFilter.PageSize" />
        </div>
      </div>
      <div class="form-group row">
        <label for="MinPrice" class="col-sm-4 col-form-label">Lágmarksverð</label>
        <div class="col-sm-8">
          <input id="MinPrice" class="form-control" type="number" v-model="searchFilter.MinPrice" />
        </div>
      </div>
      <div class="form-group row">
        <label for="MaxPrice" class="col-sm-4 col-form-label">Hámarksverð</label>
        <div class="col-sm-8">
          <input id="MaxPrice" class="form-control" type="number" v-model="searchFilter.MaxPrice" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'SearchFilter',
  props: ['searchFilter', 'providers'],
  data () {
    return {}
  }
}
</script>


// WEBPACK FOOTER //
// src/components/SearchFilter.vue